import React from 'react'
import Service from './Service'
export default function Services() {
    document.title = "Portfolio - SERVICES"

    return (
        <section className="services">
            <h2 className="after-line">Services</h2>
            <h3 className="heading">My Services</h3>
            <div className="services-content">
                <Service
                icon={<><i className="fa-solid fa-globe"></i></>}
                heading="Web developer"
                content="I can design and build static websites or dynamic web applications using HTML, CSS, and JavaScrip.
                Ensuring that wesites are optimized and look great on all devices and screen sizes is crucial. I can
                implement resposive design techniques to achieve this."
                />
            </div>
        </section>
    )
}
